export interface ChatPromptContextEntityDefinition {
  /**
   * Chave do id no bloco do prompt. Usa o nome TÉCNICO da entidade, que é o que as
   * tools esperam — daí `approval` virar `review_id`.
   */
  readonly idKey: string;
  /**
   * Nome de produto, exibido ao usuário e no bloco do prompt.
   */
  readonly label: string;
}

/**
 * Fonte ÚNICA do que pode virar contexto de tela para a Iara.
 *
 * Tipo, chave de id e rótulo nascem daqui. O renderizador do prompt, o enum
 * GraphQL da API e o chip do client todos DERIVAM deste objeto — nenhum deles
 * redeclara a lista. Acrescentar uma entidade é editar só este arquivo (e rodar o
 * codegen do client, que reflete o enum da API).
 *
 * A ordem é contrato: segue a CONTENÇÃO, do mais amplo ao mais específico, e o
 * consumidor toma a última entidade presente como a "atual".
 *
 * Um fluxo contém etapas, uma etapa contém cards, um card contém tarefas e
 * aprovações — por isso `stage` vem ANTES de `card`. Inverter os dois faz o
 * consumidor tratar a etapa como a entidade atual quando um card está aberto, o
 * que é errado: a etapa é onde o card está, não o que o usuário está olhando.
 */
export const CHAT_PROMPT_CONTEXT_ENTITIES = {
  screen: { idKey: 'screen', label: 'Tela' },
  database: { idKey: 'database_id', label: 'Base' },
  pipe: { idKey: 'pipe_id', label: 'Fluxo' },
  stage: { idKey: 'stage_id', label: 'Etapa' },
  card: { idKey: 'card_id', label: 'Card' },
  task: { idKey: 'task_id', label: 'Tarefa' },
  approval: { idKey: 'review_id', label: 'Aprovação' },
} as const satisfies Record<string, ChatPromptContextEntityDefinition>;

export type ChatPromptContextEntityType = keyof typeof CHAT_PROMPT_CONTEXT_ENTITIES;

/**
 * Todos os tipos, na ordem de especificidade declarada acima.
 */
export const CHAT_PROMPT_CONTEXT_ENTITY_TYPES = Object.keys(
  CHAT_PROMPT_CONTEXT_ENTITIES,
) as ChatPromptContextEntityType[];
